import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../css/pagination.css";
import moment from "moment/moment";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { BsCaretDownFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import OrderView from "../../Pages/Products/OrderView";

const PER_PAGE = 25;

const BuyerOrders = () => {
  const [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [activeOrder, setActiveOrder] = useState(null);
  const [detailOrder, setDetailOrder] = useState(false);
  
  // const userData = useSelector((state) => state?.auth?.user?.user);
  // const navigate = useNavigate();
  const [q, setQ] = useState("");
  const list = [
    "unpaid",
    "shipped",
    "delivered",
    "cancelled",
    "pending",
  ];

  function searchData() {
    return Data.filter((user) => {
      if (q === "") {
        return user;
      } else if (user?.status.toLowerCase().includes(q.toLowerCase())) {
        return user;
      } else return user;
    });
  }

  const fetchRequests = () => {
    let config = {
      method: "get",
      url: Server2 + "/admin/get-orders",
      data: {
        id: userData._id
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        console.log(response.data);
        response.data.sort(
          (b, c) => new Date(c.createdAt) - new Date(b.createdAt)
        );
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // API'S Approved request
  const markRefund = (e) => {
    const data = {
      id: e,
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/override-refund",
      data: data,
    };

    axios(config)
      .then(function (response) {
        // fetchRequests();
        console.log(response.data, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error refunding");
      });
  };
  
  // API'S Approved request
  const updateOrder = (id, action) => {
    const data = {
      id,
      action
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/order-update",
      data: data,
    };

    axios(config)
      .then(function (response) {
        fetchRequests();
        console.log(response.data, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error Order Update");
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchRequests();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData = Data.length === 0 ? null : searchData().slice(offset, offset + PER_PAGE).map((order, index) => (
    <tbody key={index}>
      <tr>
        <td>
          <div className="d-flex px-2 py-1">
            <div>
              {/* <img
                src={ order.buyer.profile_pic ? order.buyer.profile_pic : "/img/upload-photo.png" }
                className="avatar avatar-sm me-2"
                alt="user1"
              /> */}
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h6 className="mb-0 text-sm text-capitalize ">
                {order.buyer.fname}
              </h6>
              <p className="text-xs text-secondary mb-0">
                {order.buyer.email}
              </p>
            </div>
          </div>
        </td>
        <td>
          <div className="d-flex px-2 py-1">
            <div>
              {/* <img
                src={ order.seller.profile_pic ? order.seller.profile_pic : "/img/upload-photo.png" }
                className="avatar avatar-sm me-2"
                alt="user1"
              /> */}
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h6 className="mb-0 text-sm text-capitalize ">
                {order.seller.fname}
              </h6>
              <p className="text-xs text-secondary mb-0">
                {order.seller.email}
              </p>
            </div>
          </div>
        </td>
        <td>
        {order.items.map(product => (
          <div className="py-1">
            <div className="mb-1">
              <h6 className="mb-0 text-sm text-capitalize ">
                {product.productName}
              </h6>
            </div>
            <div className="d-flex flex-column justify-content-center">
              <img
                src={ product.image ? product.image : "/img/upload-photo.png" }
                className="avatar avatar-sm me-2 rounded-1"
                alt="user1"
              />
            </div>
          </div>
        ))}
        </td>
        <td className="align-middle text-center">
          <span
            className={`badge badge-sm ${
                order.orderStatus === "unpaid" ? "bg-gradient-secondary"
              : order.orderStatus === "pending" ? "bg-gradient-warning"
              : order.orderStatus === 'confirmed' || order.orderStatus === 'shipped' ? "bg-gradient-primary" 
              : order.orderStatus === "delivered" ? "bg-gradient-success"
              : "bg-gradient-danger"
            }`}
          >
            {order.orderStatus}
          </span>
        </td>
        <td className="align-middle">
          <div className="ms-3">
            <p><span>Subtotal:</span> {order.subtotal}</p>
            {/* <p><span>Tax:</span> {order.order.tax}</p>
            <p><span>Total:</span> {order.order.totalAmount}</p> */}
          </div>
        </td>
        <td className="align-middle">

            {moment(order.createdAt).format("MMMM Do, YYYY  h:mm A")}

        </td>
        <td className="align-middle">
          <div className="d-flex justify-content-center ">
            {/* <Button style={{ background: '#6148a1', border: 'none' }} onClick={() => {
             
            }}>View</Button>
            <Button style={{ background: '#6148a1', border: 'none' }} onClick={() => {
            }}>Refund</Button> */}
            <Dropdown className="border-0 rounded-2 add-btn fw-bold">
              <Dropdown.Toggle
                className="border-0"
                id="dropdown-basic"
                aria-expanded="false"
                style={{ backgroundColor: "#6148a1" }}
              >
                <button
                  type="button"
                  className="bg-transparent border-0 text-white"
                  data-bs-toggle="button"
                >
                  <spam className="d-inline postition-relative text-white">
                    Take Action
                  </spam>
                </button>
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-100 text-center">
                <Dropdown.Item
                  eventKey="1"
                  onClick={() =>  {
                    setActiveOrder(order.order);
                    setDetailOrder(true)
                  }}
                  style={{ fontSize: 13 }}
                  >
                  View
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="2"
                  onClick={() =>  {
                    if(order.orderStatus === 'delivered' || order.orderStatus === 'shipped') alert('Delivered')
                    else updateOrder(order._id, 'cancelled')
                  }}
                  style={{ fontSize: 13 }}
                  >
                  Cancel Order
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </td>
      </tr>
    </tbody>
  ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>All Orders</h6>
                  </div>
                  <div className="card-body px-0 pt-0 pb-2 task" style={{ height: "73vh", overflow: "auto" }}>
                    <div className="table-responsive p-0">
                      <table className="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase">Buyer</th>
                            <th className="text-uppercase">Seller</th>
                            <th className="text-uppercase">Product(s)</th>
                            <th className="text-center">
                              <Dropdown className="">
                                <Dropdown.Toggle className="border-0 p-0" variant="" id="dropdown-basic" aria-expanded="false">
                                  <span className="fs-6 fw-bold text-uppercase" style={{ color: "#67748e" }} >
                                    Status{" "}
                                    <BsCaretDownFill size={12}/>
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu">
                                <Dropdown.Item onClick={() => { setQ("") }} >
                                  <span className="fw-bold">All Orders</span>
                                </Dropdown.Item>
                                  { list.map((e) =>
                                  <Dropdown.Item onClick={() =>  setQ(e) } >
                                    <span className="fw-bold">{e}</span>
                                  </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </th>
                            <th className="text-uppercase">Amounts</th>
                            <th className="text-uppercase ps-2">Last Processed</th>
                            <th className="text-uppercase ps-5">Action</th>
                          </tr>
                        </thead>
                        {currentPageData}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div className=" mt-4" style={{ padding: 2, boxSizing: "border-box", width: "100%" }}>
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={<MdOutlineNavigateNext style={{ fontSize: 18, width: 150 }}/>}
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={<GrFormPrevious style={{ fontSize: 18, width: 150 }}/>}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          { detailOrder && <OrderView activeOrder={activeOrder} setActiveOrder={setActiveOrder} setDetailOrder={setDetailOrder} getOrders={()=>fetchRequests()} /> }

        </>
      )}
    </>
  );
};

export default BuyerOrders;